/** Fixed palette (full class names so Tailwind keeps them). Text is white on every one. */
const AVATAR_COLORS = Object.freeze([
  'bg-orange-500',
  'bg-blue-500',
  'bg-purple-500',
  'bg-rose-500',
  'bg-emerald-600',
  'bg-pink-500',
  'bg-cyan-600',
  'bg-amber-600',
]);

/**
 * Background classes of a member's initials avatar. The color follows the name, so the same
 * person always gets the same one.
 *
 * @param {string} [seed] Usually the display name.
 */
export const getAvatarColorClass = (seed = '') => {
  const hash = [...String(seed)].reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) >>> 0, 7);
  return `${AVATAR_COLORS[hash % AVATAR_COLORS.length]} border-transparent text-white`;
};
